export type BuildingOptionSource = {
  id: number;
  address: { street: string; postal_code: string; city: string };
};

export type WritableBuildingSource = BuildingOptionSource & {
  has_write_permission: boolean;
  economic_unit: { portfolio: { has_write_permission: boolean } };
};

export type BuildingSelectOption = {
  value: number;
  label: string;
};

/** Address-labelled options, locale-sorted. Use when the query already filtered by write permission. */
export const toBuildingSelectOptions = (buildings: BuildingOptionSource[]): BuildingSelectOption[] =>
  buildings
    .map(({ id, address }) => ({
      value: id,
      label: `${address.street}, ${address.postal_code} ${address.city}`,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

/** Same, but drops the buildings the current user may not write consumptions to. */
export const toWritableBuildingOptions = (buildings: WritableBuildingSource[]): BuildingSelectOption[] =>
  toBuildingSelectOptions(
    buildings.filter(
      ({ has_write_permission, economic_unit }) => has_write_permission || economic_unit.portfolio.has_write_permission,
    ),
  );
